import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';
import { commonSelectors, createQcsThunks, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import type { InvoiceItemType, InvoiceItemsState } from './invoiceItemTypes';
import { INVOICE_ITEMS_REDUCER_KEY } from './invoiceItemTypes';
import invoiceItemsApi from './invoiceItemsApi';

// Define the initial state using that type
const initialState: InvoiceItemsState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/invoiceItems/invoiceItemsSlice.ts');

const entityAdapter = createResourceEntityAdapter<InvoiceItemType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: INVOICE_ITEMS_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(invoiceItemsActions.fetch());
      },
      api: invoiceItemsApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const invoiceItemsActions = slice.actions;
export const invoiceItemsSelectors = slice.selectors;
export { slice as invoiceItemsSlice };

export default slice.reducer;
